import { jsxs as m, jsx as s } from "react/jsx-runtime";
import { Divider as i } from "./index.es18.js";
import f from "./index.es5472.js";
import { FooterButtonGroup as n } from "./index.es5473.js";
import { FooterRightControls as p } from "./index.es5474.js";
import { FooterLeftControls as l } from "./index.es5475.js";
const o = ({ hasDivider: r, children: t, ref: e }) => /* @__PURE__ */ m("footer", { className: f.footer, ref: e, children: [
  r && /* @__PURE__ */ s(i, {}),
  t
] });
o.ButtonGroup = n;
o.RightControls = p;
o.LeftControls = l;
export {
  o as CardFooter
};
//# sourceMappingURL=index.es684.js.map
